export function sleep(ms: number): Promise<void> {
  process.env.NODE_ENV === "development" && console.log(`Sleeping for ${ms}ms`)
  return new Promise((resolve) => setTimeout(resolve, ms))
}
